<template>
  <InspectionRecords/>
</template>
<script>
import InspectionRecords from 'operations/inspection/inspectionRecords.vue'
export default {
    components:{
      InspectionRecords
    }
}
</script>